import React from 'react';

function formatMoney(n, c, d, t) {
    var c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;

    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

function priceCalulator(price, quant, cart){
    let cartObj = cart
    let total = 0.00
    let totalprice = 0.00
    if (typeof cartObj != "undefined" && cartObj.hasOwnProperty("cartObject")) {
        if(cartObj.cartObject.length > 0){
            cartObj.cartObject.map((obj, i) =>
                total += obj.price * obj.quanitity
            );
            totalprice = formatMoney(total/100)
        }
    }else{
        totalprice = formatMoney(price * quant)
    }
    return formatMoney(totalprice);
}


function getMaxQuantity(product){
    let finalCount = 0;
    product.variants.map((variant,i) => {
        if(variant.inventory_quantity > 0){
            finalCount += variant.inventory_quantity
        }
    });
    return finalCount
}

function evaluateIfBelowMax(product, kitQuantity){
    let finalCount = 0;
    product.variants.map((variant,i) => {
        if(variant.inventory_quantity > 0){
            finalCount += variant.inventory_quantity
        }
    });
    if(kitQuantity < finalCount){
        return kitQuantity
    }else{
        return finalCount
    }
}

function evalIfSoldOut(product){
    let finalCount = 0;
    product.variants.map((variant,i) => {
        if(variant.inventory_quantity > 0){
            finalCount += variant.inventory_quantity
        }
    });
    if(finalCount <= 0){
        return true
    }else{
        return false
    }
}

class FinalProductListing extends React.Component {

    constructor(props){
        // Pass props to parent class
        super(props);
        // Set initial state
        this.state = {
            productQuantity: 0,
            variantsSelected: false,
            printsClass: true,
            printsText: '',
            totalprice: '0.00',
            productprice: '0.00',
            lastCartObject: {},
            maximumQuantity: getMaxQuantity(this.props.item),
            soldOut: evalIfSoldOut(this.props.item)

        }

        this.printsStateMessage = this.printsStateMessage.bind(this);
        this.updateQuantity = this.updateQuantity.bind(this);
        this.renderImage	= this.renderImage.bind(this);
        this.renderPrintsCTA = this.renderPrintsCTA.bind(this);
        this.updateNonVariant = this.updateNonVariant.bind(this);
        this.updateQuantityFromParent	= this.updateQuantityFromParent.bind(this);
        this.getTotalFromObject = this.getTotalFromObject.bind(this);
        this.openOverlayAccessibility = this.openOverlayAccessibility.bind(this);
    }

    getTotalFromObject(cart){
        var counter = 0;

        cart.cartObjects.map((item,i) =>
            {
                counter += item.quanitity
            }
        );

        return counter;

    }

    openOverlayAccessibility(a,b,c,d,e,f){
        if(e.which == 13 || e.keyCode == 13) {
            this.props.openOverlay(a,b,c,d,e,f);
        }
    }

    updateFinalCartListing(cart){
        this.setState({
            productQuantity: this.getTotalFromObject(cart)
        });
    }

    updatePricing(price, quant, cart){
        let cartObj = cart
        var netprice = priceCalulator(price, quant, cartObj);
        this.setState({
            totalprice: netprice,
            productprice: price
        });
    }

    printsStateMessage(){
        let product = this.props.item.id
        let cart = [this.props.cart]

        let message = cart.map((productCart) => {
            let finalCount = 0;
            let myVar;
            productCart.cartObjects.map((variant,i) => {
                if(variant.quanitity > 0){
                    finalCount += variant.quanitity
                }
            });
            if (product == productCart.productID){

                if(finalCount > this.state.productQuantity){
                    clearTimeout(myVar);
                    this.setState({
                        printsClass: false,
                        printsText: 'Remove<br/>Prints'
                    }, () => {
                    });
                }else if(finalCount < this.state.productQuantity && finalCount >= 0){
                    clearTimeout(myVar);
                    this.setState({
                        printsClass: false,
                        printsText: 'Select<br/>Prints'
                    }, () => {
                    });
                }else{
                    clearTimeout(myVar);
                    this.setState({
                        printsClass: true
                    }, () => {
                    });
                }
            }
        });

    }

    updateQuantityFromParent(quantity, cart){
        let cartObj = cart
        this.setState({
            productQuantity: quantity
        }, () => {
            this.updatePricing(this.state.productprice/100, quantity, cartObj);
            this.printsStateMessage();
            this.setState({
                lastCartObject: cartObj
            });
        });
    }


    updateNonVariant(){
        if ( this.props.item.variants.length <= 2 ){
            let cartObject = {
                'productID': this.props.item.id,
                'cartObject': [{
                    id: this.props.item.variants[0].id,
                    quanitity: this.state.productQuantity,
                    price: this.props.item.variants[0].price/100
                }]
            }
            this.props.updateNonVariantOptionToCart(cartObject)
        }
    }

    updateQuantity(event){
        if (event.target.value === "" || event.target.value === null){
            this.setState({
                productQuantity: 0
            });
        } else {
            this.setState({
                productQuantity: event.target.value
            });
        }

    }

    renderImage(){
        if ( this.props.item.meta.kitFeaturedImage !== "" && this.props.item.featured_image !== null){
            return(
                <div className="product-image" style={{backgroundImage: 'url(' + this.props.item.meta.kitFeaturedImage + ')'}}>
                    <img src={this.props.item.meta.kitFeaturedImage} />
                </div>
            );
        } else if (this.props.item.featured_image !== "" && this.props.item.meta.kitFeaturedImage === null){
            return(
                <div className="product-image" style={{backgroundImage: 'url(' + this.props.item.featured_image + ')'}}>
                    <img src={this.props.item.featured_image} />
                </div>
            );
        } else {
            return(
                <div className="product-image" style={{backgroundImage: 'url(https://cdn.shopify.com/s/files/1/2437/4465/t/1/assets/500x500_500x500.png)'}}>
                    <img src="https://cdn.shopify.com/s/files/1/2437/4465/t/1/assets/500x500_500x500.png" />
                </div>
            );
        }
    }

    renderPrintsCTA(){
        var color = this.props.item.options.includes("Color");
        if ( color == true ){
            for (var prop in this.props.item.options) {
                if (this.props.item.options[prop] == 'Color') {
                    return(
                        <div className={(this.state.printsClass ? 'hide select-variants' : 'select-variants')} dangerouslySetInnerHTML={{__html: this.state.printsText}}></div>
                    )
                }
            }
        }

    }

    componentDidMount(){


    }

    render() {

        var returnImage 	= this.renderImage();
        var returnPrintsCTA = this.renderPrintsCTA();

        return (
            <li key={this.props.item.id} className="grid item" role="group" aria-label="product">
                <button id={this.props.item.id + "-final"} aria-label={"view " + this.props.item.title + " details"} className="product-upper" onClick={(e) => {this.props.openOverlay(this.props.item, this.state.productQuantity, this.props.panel, [this.props.cart], e, this.state.maximumQuantity)}} nKeyPress={(e) => {this.openOverlayAccessibility(this.props.item, this.state.productQuantity, this.props.panel, [this.props.cart], e, this.state.maximumQuantity)}}>
                    { returnImage }
                    { returnPrintsCTA }
                    { this.state.soldOut &&
                        <div class="product__sold-out">Out of Stock</div>
                    }
                </button>
                <div className="product-lower">
                    <h2 className="product__title">{this.props.item.title}</h2>
                    <div className="product__quantity">
                        <span id={this.props.item.id} className="quantity preview-tile-quant">QTY: {this.state.productQuantity}</span>
                    </div>
                    <button className="product__edit" onClick={(e) => {this.props.openOverlay(this.props.item, this.state.productQuantity, this.props.panel, [this.props.cart], e, this.state.maximumQuantity)}} onKeyPress={(e) => {this.openOverlayAccessibility(this.props.item, this.state.productQuantity, this.props.panel, [this.props.cart], e, this.state.maximumQuantity)}}>edit</button>
                </div>

            </li>
        )
    }
};

export default FinalProductListing;